import React from 'react';

import { Divider, Stack, Typography } from '@gogame/components';

import { SCALE_MONTH_TO_DATE } from '../Actions/ChartSettings/constants';
import { useChartState } from '../hooks';

const lookbackModes = {
  0: 'Day',
  1: '7 days',
  2: '10 days',
  3: '30 days',
  4: '3 days',
};
const outputs = {
  values: 'Value',
  growth: 'Growth',
};
const chartGroupings = {
  0: 'Period To date',
  1: 'By Deposit date',
};
const settingsOrder = [
  'scale',
  'lookbackMode',
  'scaleWeekStart',
  'output',
  'chartGrouping',
];

const SettingsPreview = () => {
  const chartState = useChartState();

  return (
    <Stack direction={'row'} spacing={1} padding={'0 8px 0 0'}>
      {settingsOrder.map((key, index) => {
        let value = chartState.settings[key];
        if (key === 'lookbackMode') {
          value = lookbackModes[chartState.settings[key]];
        } else if (key === 'output') {
          value = outputs[chartState.settings[key]];
        } else if (key === 'chartGrouping') {
          value = chartGroupings[chartState.settings[key]];
        } else if (value === SCALE_MONTH_TO_DATE) {
          value = 'Month to date';
        }

        return (
          <Stack direction={'row'} spacing={1} key={key}>
            <Typography
              style={{ textTransform: 'capitalize', fontSize: 8 }}
              color={'textSecondary'}
            >
              {value}
            </Typography>
            {index !== settingsOrder.length - 1 ? (
              <Divider orientation={'vertical'} />
            ) : null}
          </Stack>
        );
      })}
    </Stack>
  );
};

export default SettingsPreview;
